import { Box } from '@mui/material'
import { RotateSpinner } from 'react-spinners-kit'
import { useEffect } from 'react'
import { useSnackbar } from 'notistack'
import { useDispatch } from 'react-redux'
import { isNotEmpty } from '../../utils/helpers'

const LoaderWithErrorHandler = ({ store, resetAlertHandler, transparent, Skeleton }) => {
  const { enqueueSnackbar } = useSnackbar()
  const dispatch = useDispatch()

  useEffect(() => {
    if (isNotEmpty(store?.alert?.message)) {
      enqueueSnackbar(store.alert.message, { variant: store.alert.severity })
      dispatch(resetAlertHandler())
    }
  }, [store])

  const isLoading = Boolean(store?.loading === true);
  const isFetching = typeof store?.loading === 'object' ? store?.loading?.fetch : false;
  const isMutating = typeof store?.loading === 'object' ? store?.loading?.mutate : false;

  if (Skeleton && (isFetching || isLoading)) {
    return <Skeleton size={store?.pageNumber === 0 ? 4 : 2} />
  }

  return (
    <Box sx={[(isMutating || isLoading || isFetching) &&
    styles.root, transparent && styles.transparent]}>
      <RotateSpinner size={70} color="#29cc8b" loading={isMutating || isLoading || isFetching} />
    </Box>
  )
}

const styles = {
  root: {
    position: 'fixed',
    zIndex: 9999,
    backgroundColor: 'rgb(247 249 251 / 74%)',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  transparent: {
    backgroundColor: 'transparent',
  },
}

export default LoaderWithErrorHandler
